import { connect } from "react-redux";

import { post } from "../../../../../../../actions/general";
import { editTask } from "../../../../../../../store/plan/actions";

import Systems from "./Systems";

export default connect(null, { post, editTask })(Systems);
